import React from 'react';
import ReactDOM from 'react-dom';

type Props = {
  children: any;
  position: any;
  visible: boolean;
};
function PortalTooltip({ children, position, visible }: Props) {
  const el = document.body;
  if (!visible) {
    return null;
  }
  return ReactDOM.createPortal(<>{children}</>, el);
}

export default PortalTooltip;
